import { NextPage, NextPageContext } from 'next';
import { NextRouter, useRouter } from 'next/router';

import ConsumptionPage from 'src/components/consumptionPage';
import { ContentTypes } from 'src/components/thumbnail/types';
import { contentSpecificCheck } from 'src/utils/ConsumptionHelper/ConsumptionHelper';
import { getServerData } from 'src/utils/ConsumptionHelper/ConsumptionHelperForServer';

const WebSeriesConsumptionPage: NextPage<any> = ({
  contentLiteData = null,
  seoMetaObject,
  seoMetaAssets,
  botRails
}) => {
  const router = useRouter();
  const { locale }: NextRouter = router;
  const showDetails =
    contentLiteData?.showDetail || contentLiteData?.tvshow_details;
  const contentLiteAssetData =
    contentLiteData?.assetDetails || contentLiteData || {};
  const showId = showDetails?.id || router.query.showId;
  const showName = showDetails?.title || showDetails?.original_title;

  const { asset_subtype, actors, directors, extended } =
    contentLiteData?.showDetail || contentLiteData || {};

  const {
    title: episodeName,
    id: episodeId = router.query.episodeId,
    season_details,
    orderid: episodeNumber
  } = contentLiteAssetData;

  const assetDetailsFromServer = contentLiteData
    ? {
        ...contentLiteAssetData,
        id: episodeId,
        tvshow_name: showName,
        episodeNumber,
        asset_subtype,
        showDetails,
        actors,
        directors,
        extended,
        seasonId: season_details?.[0]?.id,
        episodeName: episodeName
      }
    : null;

  return (
    <ConsumptionPage
      pageDetails={{
        locale: locale as string,
        contentType: ContentTypes.webSeries,
        showId: showId,
        episodeId
      }}
      contentLiteData={assetDetailsFromServer}
      seoMetaObject={seoMetaObject}
      seoMetaAssets={seoMetaAssets}
      botRails={botRails}
    />
  );
};

export async function getServerSideProps(context: NextPageContext) {
  const episodeId = context.query.episodeId as string;
  const pathName = decodeURI(context.req?.url as string);

  const contentObject = await contentSpecificCheck(episodeId, pathName);
  if (contentObject) {
    return {
      ...contentObject
    };
  }

  const serverResponse = await getServerData({
    context,
    contentId: episodeId,
    contentType: ContentTypes.tvshows
  });

  return {
    ...serverResponse
  };
}

export default WebSeriesConsumptionPage;
